import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendStoreSaveContainer from '../../../containers/recommend/store/RecommendStoreSaveContainer';
import { recommendStoreActions } from '../../../store/modules/recommend/store';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_STORE_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_STORE_SAVE_MODEL,
} from '../../../store/modules/recommend/store/models';
import { RECOMMEND_STORE_PAGE_NAME } from '../../../constants/service/app/recommendStoreConstants';

class RecommendStoreCopy extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendStoreSave'],
      value: RECOMMEND_STORE_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendStoreId) => {
    const { prepareCopyRecommendStore } = this.props;

    prepareCopyRecommendStore({
      recommendStoreId,
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_STORE_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_STORE_PAGE_NAME.RECOMMEND_STORE_COPY}>
        <RecommendStoreSaveContainer typeDisabled={true} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendStoreActions.setData,
  prepareCopyRecommendStore: recommendStoreActions.prepareCopyRecommendStore,
};

export default connect(null, mapDispatchToProps)(withRouter(RecommendStoreCopy));
